// Time helpers shared by the auction list cards and the lot page.
export const timeLeftParts = (target, now = Date.now()) => {
  const ms = Math.max(0, new Date(target).getTime() - now);
  return {
    expired: ms <= 0,
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms % 86400000) / 3600000),
    minutes: Math.floor((ms % 3600000) / 60000),
    seconds: Math.floor((ms % 60000) / 1000),
  };
};

export const pad = (n) => String(n).padStart(2, '0');

// The api's public auction shape → the fields the components read. A
// `published` lot that is neither live nor upcoming has passed endsAt and is
// waiting for the close cron, so it reads as ended. The next-bid bounds come
// from the api (it enforces them), never re-derived here.
export const normalizeAuction = (a) => {
  const phase = a.status === 'ended' || a.status === 'cancelled'
    ? a.status
    : a.live ? 'live' : a.upcoming ? 'scheduled' : 'ended';
  return {
    ...a,
    phase,
    startPrice: a.startingPrice,
    topBid: a.bidCount > 0 ? a.currentPrice : null,
    bids: a.bids || [],
  };
};

// The lot's share preview (og:image). The api's `image` is the admin's cover
// URL, else the first item's thumbnail. A product `thumb_` is 300px, which
// scrapers show as a small tile, so it becomes the 960px `default_` beside it.
// Card originals are often smaller than their thumbnails, so cards and covers
// pass through unchanged.
export const auctionShareImage = ({ image }) => image
  ? image.replace('/product-images/thumb_', '/product-images/default_')
  : undefined;

// Explicit shop timezone keeps SSR (UTC) and the customer's browser identical.
export const formatBidTime = (dateString, locale = 'ro') => new Intl.DateTimeFormat(locale === 'en' ? 'en-GB' : 'ro-RO', {
  timeZone: 'Europe/Bucharest', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
}).format(new Date(dateString));

export const formatAuctionTime = (dateString, locale = 'ro') => new Intl.DateTimeFormat(locale === 'en' ? 'en-GB' : 'ro-RO', {
  timeZone: 'Europe/Bucharest', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
}).format(new Date(dateString));
